import type { ReactElement } from 'react'
import Box from '@mui/material/Box'
import { RiFileTextLine, RiMegaphoneLine, RiWallet3Line } from 'react-icons/ri'

import vuesaxDollarCircleLinearSvg from '@/assets/tenants/overview/vuesax-dollar-circle-linear.svg?raw'

import { SENSEMAKER_OVERVIEW_METRIC_ICON_INNER_PX } from '../../lib/sensemaker-overview-layout'

const ICON_COLOR = '#fff'

function metricRemixIcon(Icon: typeof RiMegaphoneLine): ReactElement {
  return <Icon size={SENSEMAKER_OVERVIEW_METRIC_ICON_INNER_PX} color={ICON_COLOR} aria-hidden />
}

/** Figma `17:581` — remix megaphone-line. */
export function OverviewMegaphoneIcon(): ReactElement {
  return metricRemixIcon(RiMegaphoneLine)
}

/** Figma `17:589` — remix file-text-line (SDS File text). */
export function OverviewFileTextIcon(): ReactElement {
  return metricRemixIcon(RiFileTextLine)
}

/** Figma `17:611` — remix wallet-3-line. */
export function OverviewWalletIcon(): ReactElement {
  return metricRemixIcon(RiWallet3Line)
}

/**
 * Figma `17:596` / `17:597` — vuesax/linear/dollar-circle on red tile.
 * Stroke glyph must not use MUI SvgIcon (its fill rule breaks vuesax linear paths).
 */
export function OverviewDollarCircleMetricIcon(): ReactElement {
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        width: SENSEMAKER_OVERVIEW_METRIC_ICON_INNER_PX,
        height: SENSEMAKER_OVERVIEW_METRIC_ICON_INNER_PX,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: ICON_COLOR,
        lineHeight: 0,
        '& svg': {
          width: SENSEMAKER_OVERVIEW_METRIC_ICON_INNER_PX,
          height: SENSEMAKER_OVERVIEW_METRIC_ICON_INNER_PX,
          display: 'block',
        },
      }}
      dangerouslySetInnerHTML={{ __html: vuesaxDollarCircleLinearSvg }}
    />
  )
}
